const timers = {
	preloadSpinnerTimer: 1500,
};

export default timers;
